import styled from 'styled-components';

const HeaderText = styled.div`
  padding: 10px;
  border-radius: 4px;
  background-color: #fff;
  font-size: 16px;
  line-height: 1.4;
  text-align: justify;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
`;

const BoldText = styled.strong`
  font-size: 20px;
  display: block;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
`;

export {
  HeaderText,
  BoldText
}



// WEBPACK FOOTER //
// ./src/components/HeaderInfo/styles.js